import { render, staticRenderFns } from "./NonViaggiStandardPage.vue?vue&type=template&id=1ea25ec4&scoped=true&"
import script from "./NonViaggiStandardPage.vue?vue&type=script&lang=js&"
export * from "./NonViaggiStandardPage.vue?vue&type=script&lang=js&"
import style0 from "./NonViaggiStandardPage.vue?vue&type=style&index=0&id=1ea25ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea25ec4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
